import { defineComponent } from "vue";
import { brightenKeyword } from "@/hooks/lightKeyword";
import _ from "lodash";
import Loading from "@/baseui/loading/loading.vue";
import PlayListBefore from "@/baseui/playListBefore/playListBefore.vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "videoList",
  props: {
    videoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isBlod: {
      type: Boolean,
      default: false
    },
    isShowLoading: {
      type: Boolean,
      default: true
    },
    isScroll: {
      type: Boolean,
      default: true
    },

    /* 高亮关键字 */
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();
    /* 防抖 */

    var scrollLoad = _.debounce(function () {
      emit("scrollLoad");
    }, 500);
    /* 关键字高亮 */


    var lightKeyword = brightenKeyword;
    /* mv点击事件 */

    var mvClick = function mvClick(id) {
      router.push("/videodetail/".concat(id));
    };

    return {
      scrollLoad: scrollLoad,
      lightKeyword: lightKeyword,
      mvClick: mvClick
    };
  },
  components: {
    Loading: Loading,
    PlayListBefore: PlayListBefore
  }
});